// extracted by mini-css-extract-plugin
module.exports = {"send-sms-form":"AnswerQuestion_send-sms-form__2hf3d"};